import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendTeamsChatMessage } from '../../../services/teamsChat';

export const ThunkSendTeamsChatMessage = createAsyncThunk(
  'teamsChat/sendTeamsChatMessage',
  async ({ chatId, message }: { chatId: number; message: string }) =>
    sendTeamsChatMessage(chatId, { message }).then(r => r.data),
);

export default {};
